import { useMemo } from 'react';

type Props = {
  text: string;
  maxLength: number;
};

export const TextEllipsisMiddle = ({ text, maxLength }: Props) => {
  const displayText = useMemo(() => {
    if (text.length <= maxLength || maxLength < 5) {
      return text;
    }

    // We want equal length of text on both sides -
    // Since ellipsis is 3 dots, subtract 3 from max length
    // to ensure the returned string is never longer than maxLength
    const prefixSuffixLength = Math.floor((maxLength - 3) / 2);

    const prefix = text.slice(0, prefixSuffixLength);
    const suffix = text.slice(-prefixSuffixLength);

    return `${prefix}...${suffix}`;
  }, [text, maxLength]);

  return <>{displayText}</>;
};
